import { environment } from '@env/environment';

export interface LangItem<Code extends string = string> {
  code: Code;
  labelKey: string;
  flag: string;
}

export enum AppLang {
  ES = 'es-ES',
  EN = 'en-US',
}

export type SupportedLang = (typeof environment.supportedLanguages)[number];

export const LABEL_KEY_MAP: Record<SupportedLang, string> = {
  'es-ES': 'LANGUAGE.ES',
  'en-US': 'LANGUAGE.EN',
};

export const LABEL_FLAG_MAP: Record<SupportedLang, string> = {
  'es-ES': './assets/media/flags/spain.svg',
  'en-US': './assets/media/flags/united-states.svg',
};
